import {
    Style
} from '@/libs/style.js';

export default (Vue) => {
    Vue.customElement('dv-scroll-board-1', {
        template: /* html */ `
        <div class="app-monitoring-scroll">
            <dv-scroll-board :config="boardConfig" style="height:100%;color:#fff;"></dv-scroll-board>
        </div>
        `,
        props: ["config"],
        computed: {
            boardConfig: {
                get() {
                    return JSON.parse(this.config);
                }
            }
        },
        data() {
            return {
                html: ``
            }
        },
        mounted() {
            Style( /* css */ `
            .app-monitoring-scroll{
                height: calc(100% - 50px);
            overflow: hidden;
            padding: 5px;
            box-sizing: border-box;
            }
            `);
        }
    });
}